var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#E2F7F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#E2F7F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 18.25C5.75 18.5266 5.97344 18.75 6.25 18.75H17.75C18.0266 18.75 18.25 18.5266 18.25 18.25V11.6875H5.75V18.25ZM17.75 7.375H15.125V6.375C15.125 6.30625 15.0688 6.25 15 6.25H14.125C14.0563 6.25 14 6.30625 14 6.375V7.375H10V6.375C10 6.30625 9.94375 6.25 9.875 6.25H9C8.93125 6.25 8.875 6.30625 8.875 6.375V7.375H6.25C5.97344 7.375 5.75 7.59844 5.75 7.875V10.625H18.25V7.875C18.25 7.59844 18.0266 7.375 17.75 7.375Z",
    fill: "#6DD8CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.0fbcd459001175cae1ac4ad5c6270114.svg";
export { ForwardRef as ReactComponent };